$( document ).ready(function() {
  
  
  // Get variation metafield (price as shown)
  // https://alanryan.dev/tips/product-variant-metafields/
  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};
  
  
  let lastUrl = location.href; 
  new MutationObserver(() => {
    const url = location.href;
    if (url !== lastUrl) {
      lastUrl = url;
      onUrlChange();
    }
  }).observe(document, {subtree: true, childList: true});
 
 
function onUrlChange() {
  //alert('URL changed!', location.href);
  var getVariant = getUrlParameter('variant'); //this works
  const currentVariantId = getVariant;
  //extraVariantInfo(getVariant);

  //console.log(currentVariantId);
  //$('.variant_info_1').attr('variant', getVariant);
   
}


// customize button active/inactive
$("#customize-last").click(function(e){
  	e.preventDefault();
	$(".opt--customize").click();
  	//$(this).attr('disabled','disabled');
  	$(this).hide();
  	$(this).text(current);
});

if ($(".opt--customize").hasClass("active")) {
  //$("#customize-last").removeAttr('disabled');
  $("#customize-last").show();
}

// on variant change
$(window).on("cc-variant-updated.product-swatches", (e, args) => {
  if ($(".opt--customize").hasClass("active")) {
  	//$("#customize-last").attr('disabled','disabled');
    $("#customize-last").hide();
    $("#mto-range").css("display", "block");
  } else {
    //$("#customize-last").removeAttr('disabled');
    $("#customize-last").show();
    $("#mto-range").css("display", "none");
  }

});



  function toggleVirtualOptions() {
    var experienceValue = $('#experience').val();

    if (experienceValue === 'Virtual' || experienceValue === 'In Store') {
      $('#virtual-options').show();
    } else {
      $('#virtual-options').hide();
    }

    if(experienceValue === 'In Store'){
      $('#visit-us-text').show();
    } else {
      $('#visit-us-text').hide();
    }
  }

  // Initial call to set the correct visibility on page load
  toggleVirtualOptions();

  // Event listener for dropdown changes
  $('#experience').on('change', toggleVirtualOptions);
  
  


// open external links in new tab https://help.shopify.com/en/manual/online-store/themes/themes-by-shopify/vintage-themes/customizing-vintage-themes/open-external-links-in-new-tab
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

// hispanic heritage sneaker product page
/*
$( window ).on("load", function() {
  const currentLatamCountry = $('#hispanicheritagex').val();
    console.log(currentLatamCountry);
  var selectorLoad = `.media-column:has(img[alt="${currentLatamCountry}"])`;
    console.log(selectorLoad);
  $(selectorLoad).show();

  var hideOthersLoad = `.media-column:not(:has(img[alt="${currentLatamCountry}"]))`;
    console.log(hideOthersLoad);
  $(hideOthersLoad).hide();
});
  */
  
/*
$('#hispanicheritagex').change(function(){
  const currentLatamCountry = $(this).val();
  console.log(currentLatamCountry);

  //$('.media-column:has(`img[alt="'${currentLatamCountry}'"]`)').hide();

  //$('.media-column').hide();


  
  
  //var selector = `.media-column:has(img[alt="${currentLatamCountry}"])`;
  //$(selector).show();

  //var hideOthers = `.media-column:not(:has(img[alt="${currentLatamCountry}"]))`;
  //$(hideOthers).hide();




  
  //document.querySelectorAll('[thumbnail-alt]').forEach(img => img.style.display = 'none');
  //const thumbnailSelector = `[thumbnail-alt =  '${currentLatamCountry}']`
  //document.querySelectorAll(thumbnailSelector).forEach(img => img.style.display = 'block');


});  
*/


$( window ).on("load", function() {
  $('#hispanicheritagex').trigger('change');
  
});

$('#hispanicheritagex').change(function() {
  const currentLatamCountry = $(this).val();

  $('.swiper-slide').each(function() {
    var img = $(this).find('img[alt]').first();
    var imgAlt = img.attr('alt');
    if (imgAlt === currentLatamCountry) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });
  
});







  


  
  
});



